const CV = {
  ibanLength: 25,
};
export { CV };
